export enum paymentType {
  CARD = "CARD",
  BANK = "BANK",
  CASH = "CASH",
  /** Mobile wallet / home delivery and other non-card non-cash rails. */
  OTHER = "OTHER",
}

/** Cash pickup location: subdivision + cash network (payer). */
export interface ICashPickupDetails {
  stateCode: string;
  payerId: string;
  payerName: string;
}

/** Destination bank account — catalog bank + digits or a saved PM id. */
export interface IBankAccountDetails {
  source: "new" | "saved";
  /** Catalog payer code used to pin the BANK_ACCOUNT quote SKU. */
  bankId?: string;
  bankName?: string;
  accountNumber?: string;
  paymentMethodId?: string;
  last4?: string;
}

export interface IPaymentSelected {
  cardId: string | null;
  type: paymentType;
  brand: string;
  /** Required when `type === CASH` — state + payer for the binding quote SKU. */
  cashPickup?: ICashPickupDetails;
  /** Required when `type === BANK` — bank + account (or saved PM). */
  bankAccount?: IBankAccountDetails;
}

export interface IPaymentState {
  payment: IPaymentSelected | null;
}

export interface IReceivetState {
  type: paymentType | null;
  receiveSelected: string | null;
  brand: string | null;
}
